import React from "react";

export default function OrderList({ fill, size, className }) {
  return (
    <svg
      className={className}
      width={size || "18"}
      height={size || "18"}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 9V2.75C16 2.41848 15.8683 2.10054 15.6339 1.86612C15.3995 1.6317 15.0815 1.5 14.75 1.5H2.25C1.91848 1.5 1.60054 1.6317 1.36612 1.86612C1.1317 2.10054 1 2.41848 1 2.75V15.25C1 15.5815 1.1317 15.8995 1.36612 16.1339C1.60054 16.3683 1.91848 16.5 2.25 16.5H8.5"
        stroke={fill || "#000"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8333 14.833C13.214 14.833 14.3333 13.7137 14.3333 12.333C14.3333 10.9523 13.214 9.83301 11.8333 9.83301C10.4526 9.83301 9.33331 10.9523 9.33331 12.333C9.33331 13.7137 10.4526 14.833 11.8333 14.833Z"
        stroke={fill || "#000"}
        strokeWidth="1.6"
      />
      <path
        d="M13.9166 14.0003L16 15.667M4.33331 5.66699H12.6666M4.33331 9.00033H7.66665"
        stroke={fill || "#000"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
